module.exports = __webpack_public_path__ + "img/custom-amount.1337c6d8.svg";